import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Item} from './items';

@Injectable()
export class ItemService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('items?' + params.toString()).map((response: Response) => response.json());
    }

    getAllGroups() {
        return this.http.get('groups/all').map((response: Response) => response.json());
    }

    getAllItems() {
        return this.http.get('items/all').map((response: Response) => response.json());
    }

    getAllpurchased() {
        return this.http.get('pur/all').map((response: Response) => response.json());
    }

    getitemTaxes(_id: string) {
        return this.http.get('items/gettaxes/' + _id).map((response: Response) => response.json());
    }

    getitemqty(_id: string) {
        return this.http.get('items/get_item_qty/' + _id).map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('items/' + _id).map((response: Response) => response.json());
    }

    getByname(_name: string,_id: any = 0) {
      return this.http.get('itemsfound/' + _id + "/" + _name).map((response: Response) => response.json());
    }

    getBybarcode(_name: string,_id: any = 0) {
      return this.http.get('itemsbarcodefound/' + _id + "/" + _name).map((response: Response) => response.json());
    }

    getPurById(_id: string) {
        return this.http.get('purchased/' + _id).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('items/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('items/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(item: Item) {
        return this.http.post('items', item).map((response: Response) => response.json());
    }

    update(item: Item) {
        return this.http.put('items/' + item.id, item).map((response: Response) => response.json());
    }

    deletePic(_id: string) {
        return this.http.put('item/picture/delete/' + _id, {}).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('items/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/items/items.service.ts